<div class="card kpi-purple">
    <div class="card-body kpi-card">
        <h5 class="card-title">Tension locative</h5>
        <p class="card-value">
            <ng-container *ngIf="preview">-</ng-container>
            <ng-container *ngIf="!preview">
                {{ favorite.ad_city.loc_service_tensiometre.all.loc !== '-1' ? favorite.ad_city.loc_service_tensiometre.all.loc : '-' | number: '1.1-1' }} / 8
            </ng-container>
        </p>
    </div>
</div>
